// File auto generated from src/color-base.ts, using scripts/build.ts.
var neutral = {
  "white": "#ffffff",
  "dark01": "#0B163F",
  "gray01": "#F5F8F9",
  "gray02": "#E3E6EB",
  "gray02b": "#EFF1F4",
  "gray03": "#D2D4DD",
  "gray04": "#C1C2CF",
  "gray05": "#72718E"
};
var accent = {
  "aubergine": "#75647B",
  "green": "#6E9D88",
  "purple": "#556889",
  "blue": "#4B7A8A"
};
var theme = {
  "red01": {
    "name": "Reinrot",
    "ral": "3028",
    "hex": "#E42C00"
  },
  "orange01": {
    "name": "Verkehrsorange",
    "ral": "2009",
    "hex": "#D93E01"
  },
  "bikeMi": {
    "name": "BikeMi Milan",
    "ral": "???",
    "hex": "#FFC72C"
  },
  "greenMachine": {
    "name": "Green machine",
    "ral": "???",
    "hex": "#55efc4"
  },
  "green01": {
    "name": "Gelbgrün",
    "ral": "6018",
    "hex": "#4C9107"
  },
  "green02": {
    "name": "Reingrün",
    "ral": "6037",
    "hex": "#008A34"
  },
  "green03": {
    "name": "Wasserblau",
    "ral": "5021",
    "hex": "#018580"
  },
  "blue01": {
    "name": "Himmelblau",
    "ral": "5015",
    "hex": "#0074E6"
  },
  "blue02": {
    "name": "Verkehrsblau",
    "ral": "5017",
    "hex": "#005FC9"
  },
  "purple01": {
    "name": "Ultramarine blau",
    "ral": "5002",
    "hex": "#3A05B7"
  },
  "purple02": {
    "name": "Signalviolett",
    "ral": "4008",
    "hex": "#BA1ABD"
  },
  "pink01": {
    "name": "Telemagenta",
    "ral": "4010",
    "hex": "#CA007D"
  },
  "red02": {
    "name": "Himberrod",
    "ral": "3027",
    "hex": "#E02344"
  },
  "edinburghCityBike": {
    "name": "Just Eat Cycles",
    "ral": "???",
    "hex": "#EB0027"
  }
};
var themeColors = {
  "red01": {
    "primaryIsDark": true,
    "primary": "#E42C00",
    "primaryLight": "#ff5f39",
    "primaryDark": "#b12200",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#E42C00",
    "primaryText": "#E42C00",
    "link": "#E42C00",
    "white": "#ffffff",
    "selectedBackground": "#fadfd8"
  },
  "orange01": {
    "primaryIsDark": true,
    "primary": "#D93E01",
    "primaryLight": "#fe6c33",
    "primaryDark": "#a72f00",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#D93E01",
    "primaryText": "#D93E01",
    "link": "#D93E01",
    "white": "#ffffff",
    "selectedBackground": "#f9e2d8"
  },
  "bikeMi": {
    "primaryIsDark": false,
    "primary": "#FFC72C",
    "primaryLight": "#ffd76b",
    "primaryDark": "#5f4600",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#3b2c00",
    "primaryIcon": "#e3a600",
    "primaryText": "#C8443D",
    "link": "#3b2c00",
    "white": "#ffffff",
    "selectedBackground": "#fff6df"
  },
  "greenMachine": {
    "primaryIsDark": false,
    "primary": "#55efc4",
    "primaryLight": "#7cffda",
    "primaryDark": "#0a6e53",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#074d3a",
    "primaryIcon": "#00e9ac",
    "primaryText": "#074d3a",
    "link": "#074d3a",
    "white": "#ffffff",
    "selectedBackground": "#e5fcf6"
  },
  "green01": {
    "primaryIsDark": true,
    "primary": "#4C9107",
    "primaryLight": "#81d132",
    "primaryDark": "#336104",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#4C9107",
    "primaryText": "#4C9107",
    "link": "#4C9107",
    "white": "#ffffff",
    "selectedBackground": "#e4eed9"
  },
  "green02": {
    "primaryIsDark": true,
    "primary": "#008A34",
    "primaryLight": "#2dcc68",
    "primaryDark": "#005721",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#008A34",
    "primaryText": "#008A34",
    "link": "#008A34",
    "white": "#ffffff",
    "selectedBackground": "#d8ede0"
  },
  "green03": {
    "primaryIsDark": true,
    "primary": "#018580",
    "primaryLight": "#2ec8c3",
    "primaryDark": "#01524f",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#018580",
    "primaryText": "#018580",
    "link": "#018580",
    "white": "#ffffff",
    "selectedBackground": "#d8eceb"
  },
  "blue01": {
    "primaryIsDark": true,
    "primary": "#0074E6",
    "primaryLight": "#3a9dff",
    "primaryDark": "#005ab3",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#0074E6",
    "primaryText": "#0074E6",
    "link": "#0074E6",
    "white": "#ffffff",
    "selectedBackground": "#d8eafb"
  },
  "blue02": {
    "primaryIsDark": true,
    "primary": "#005FC9",
    "primaryLight": "#318ef4",
    "primaryDark": "#004796",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#005FC9",
    "primaryText": "#005FC9",
    "link": "#005FC9",
    "white": "#ffffff",
    "selectedBackground": "#d8e7f6"
  },
  "purple01": {
    "primaryIsDark": true,
    "primary": "#3A05B7",
    "primaryLight": "#6a34e8",
    "primaryDark": "#2a0386",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#3A05B7",
    "primaryText": "#3A05B7",
    "link": "#3A05B7",
    "white": "#ffffff",
    "selectedBackground": "#e1d9f4"
  },
  "purple02": {
    "primaryIsDark": true,
    "primary": "#BA1ABD",
    "primaryLight": "#e744ea",
    "primaryDark": "#8f1391",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#BA1ABD",
    "primaryText": "#BA1ABD",
    "link": "#BA1ABD",
    "white": "#ffffff",
    "selectedBackground": "#f4dcf5"
  },
  "pink01": {
    "primaryIsDark": true,
    "primary": "#CA007D",
    "primaryLight": "#f431ab",
    "primaryDark": "#97005d",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#CA007D",
    "primaryText": "#CA007D",
    "link": "#CA007D",
    "white": "#ffffff",
    "selectedBackground": "#f7d8eb"
  },
  "red02": {
    "primaryIsDark": true,
    "primary": "#E02344",
    "primaryLight": "#ff4f6e",
    "primaryDark": "#b71934",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#E02344",
    "primaryText": "#E02344",
    "link": "#E02344",
    "white": "#ffffff",
    "selectedBackground": "#fadee2"
  },
  "edinburghCityBike": {
    "primaryIsDark": true,
    "primary": "#EB0027",
    "primaryLight": "#ff3e5e",
    "primaryDark": "#b8001f",
    "primaryDarkContrast": "#ffffff",
    "primaryContrast": "#ffffff",
    "primaryIcon": "#EB0027",
    "primaryText": "#EB0027",
    "link": "#EB0027",
    "white": "#ffffff",
    "selectedBackground": "#fcd8de"
  }
};
var themeDark = {
  "red01": "#b12200",
  "orange01": "#a72f00",
  "green01": "#336104",
  "green02": "#005721",
  "green03": "#01524f",
  "blue01": "#005ab3",
  "blue02": "#004796",
  "purple01": "#2a0386",
  "purple02": "#8f1391",
  "pink01": "#97005d",
  "red02": "#b71934",
  "edinburghCityBike": "#b8001f",
  "bikeMi": "#f8b600",
  "greenMachine": "#25ecb5"
};
var paletteTheme = {
  "red01": "#E42C00",
  "orange01": "#D93E01",
  "green01": "#4C9107",
  "green02": "#008A34",
  "green03": "#018580",
  "blue01": "#0074E6",
  "blue02": "#005FC9",
  "purple01": "#3A05B7",
  "purple02": "#BA1ABD",
  "pink01": "#CA007D",
  "red02": "#E02344",
  "edinburghCityBike": "#EB0027",
  "bikeMi": "#FFC72C",
  "greenMachine": "#55efc4"
};
var paletteDark = {
  "red01": "#7e1800",
  "orange01": "#732101",
  "green01": "#193002",
  "green02": "#00240e",
  "green03": "#00201f",
  "blue01": "#004180",
  "blue02": "#002f63",
  "purple01": "#1b0254",
  "purple02": "#620e63",
  "pink01": "#64003e",
  "red02": "#8a1328",
  "edinburghCityBike": "#850016",
  "bikeMi": "#c59100",
  "greenMachine": "#13cb98"
};
var palette = {
  "red01": "#f6bfb2",
  "orange01": "#f3c5b2",
  "green01": "#c9deb4",
  "green02": "#b2dbc2",
  "green03": "#b2dad8",
  "blue01": "#b2d5f7",
  "blue02": "#b2cfee",
  "purple01": "#c3b4e9",
  "purple02": "#eabaeb",
  "pink01": "#efb2d8",
  "red02": "#f5bdc6",
  "edinburghCityBike": "#f9b2be",
  "bikeMi": "#ffeebf",
  "greenMachine": "#ccfaed"
};
var paletteLight = {
  "red01": "#ff5f39",
  "orange01": "#fe6c33",
  "green01": "#81d132",
  "green02": "#2dcc68",
  "green03": "#2ec8c3",
  "blue01": "#3a9dff",
  "blue02": "#318ef4",
  "purple01": "#6a34e8",
  "purple02": "#e744ea",
  "pink01": "#f431ab",
  "red02": "#ff4f6e",
  "edinburghCityBike": "#ff3e5e",
  "bikeMi": "#ffd76b",
  "greenMachine": "#7cffda"
};
var state = {
  "error": "#ff5f39",
  "info": "#3a9dff",
  "warning": "#fe6c33",
  "success": "#81d132"
};
export { accent, neutral, palette, paletteDark, paletteLight, paletteTheme, state, theme, themeColors, themeDark };